var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"infobar"},[_c('b-avatar',{staticClass:"mb-2",attrs:{"size":"30%","rounded":"sm"}}),_c('div',{attrs:{"id":"text-prof"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }